import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=62c897b3&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=62c897b3&prod&scoped=true&lang=css"
import style1 from "./createOrder.vue?vue&type=style&index=1&id=62c897b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c897b3",
  null
  
)

export default component.exports